import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import ArrowSelect from "rialto-icons/ArrowSelect";

import styles from "./DropdownInput.css";

const DropdownInput = ({ isRequired, onClick, placeholder, value }) => (
  <div className={styles.root} onClick={onClick}>
    <div
      className={cx(styles.input, {
        [styles.required]: isRequired && !value,
        [styles.placeholder]: placeholder && !value,
      })}
      onClick={onClick}
    >
      {value || placeholder}
    </div>
    <ArrowSelect size="xs" />
  </div>
);

DropdownInput.propTypes = {
  isRequired: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClick: PropTypes.func,
};

export default DropdownInput;
